module.exports = __webpack_public_path__ + "img/banner2_7_en.288da069.png";